(() => {
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  function initFinder(scope = document) {
    qsa('[data-sf-finder]', scope).forEach((finder) => {
      if (finder.dataset.ready) return;
      finder.dataset.ready = 'true';

      const steps = qsa('[data-step]', finder);
      const result = finder.querySelector('[data-result]');
      const progress = finder.querySelector('[data-progress]');
      const back = finder.querySelector('[data-back]');
      const resultTitle = finder.querySelector('[data-result-title]');
      const resultText = finder.querySelector('[data-result-text]');
      const resultLink = finder.querySelector('[data-result-link]');
      const configNode = finder.querySelector('[data-finder-config]');
      if (!steps.length || !configNode) return;

      let current = 0;
      let scores = { wide: 0, work: 0, barefoot: 0, handsfree: 0 };
      const config = JSON.parse(configNode.textContent);

      const showStep = () => {
        steps.forEach((step, index) => {
          step.classList.toggle('is-active', index === current);
        });
        result?.classList.remove('is-active');
        if (progress) {
          progress.style.width = `${((current + 1) / steps.length) * 100}%`;
        }
        if (back) back.hidden = current === 0;
      };

      qsa('[data-score]', finder).forEach((button) => {
        button.addEventListener('click', () => {
          const step = button.closest('[data-step]');
          qsa('[data-score]', step).forEach((item) => {
            item.classList.toggle('is-selected', item === button);
          });

          (button.dataset.score || '').split(',').forEach((part) => {
            const [key, rawValue] = part.split(':');
            if (Object.prototype.hasOwnProperty.call(scores, key)) {
              scores[key] += Number(rawValue || 1);
            }
          });

          if (current < steps.length - 1) {
            current += 1;
            showStep();
            return;
          }

          const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0];
          const chosen = config[winner] || config.wide;

          steps.forEach((stepItem) => stepItem.classList.remove('is-active'));
          resultTitle.textContent = chosen.title;
          resultText.textContent = chosen.text;
          resultLink.href = chosen.url || '#';
          result.classList.add('is-active');
          if (progress) progress.style.width = '100%';
          if (back) back.hidden = false;
        });
      });

      back?.addEventListener('click', () => {
        if (result?.classList.contains('is-active')) {
          result.classList.remove('is-active');
          current = steps.length - 1;
        } else {
          current = Math.max(0, current - 1);
        }

        scores = { wide: 0, work: 0, barefoot: 0, handsfree: 0 };
        qsa('[data-score]', finder).forEach((item) => item.classList.remove('is-selected'));
        showStep();
      });

      showStep();
    });
  }

  const init = (scope = document) => initFinder(scope);

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
